import React, { Component } from 'react';
import Container from '@mui/material/Container';
import Viewer from '../forge/Viewer';
import Projects from '../Data/sampleprojectdata.json';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { moveModel } from '../forge/Viewer-helpers';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';


// import DemoData from '../components/DemoData';

const projectDetails = Projects.find(project => project.name === localStorage.getItem('projectName'))

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};


class VisualizationView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectId: localStorage.getItem('projectName'),
      age: '',
      downloadReady: false,
      open: false,
      loading: false,
      packageReady: false
    }
  }

  handleChange = event => {
    this.setState({
      age: event.target.value,
      downloadReady: false,
      packageReady: true
    })
  }

  sleep = async (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  componentDidMount() {

  };

  runDownload = () => {

  };

  handleOpen = async () => {
    this.setState({ loading: true })
    await this.sleep(3000);
    this.setState({ open: true, loading: false })
  };

  handleClose = () => {
    this.setState({ open: false, downloadReady: true })
  };


  render() {
    return (
      <>
        {(projectDetails) &&
          <>
            <Container maxWidth="lg" sx={{ mt: 2, mb: 2, lg: 2 }} maxWidth="xl">
              <Grid container spacing={3}>

                <Grid item xs={9} md={9} lg={9}>
                  <Paper
                    sx={{
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      height: 650,
                    }}
                  >
                    <Viewer
                      // key={Math.random()}
                      viewerDiv={'forgeViewer'}
                      urn={projectDetails.modelUrn}
                      extensions={['Autodesk.Viewing.MarkupsGui']}
                      hasDwg={1}
                    />
                  </Paper>
                </Grid>
                  <Grid item xs={12} md={3} lg={3}>
                  <Paper
                      sx={{
                        p: 2, display: 'flex',
                        flexDirection: 'column',
                        height: 80,
                      }}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Platform</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={this.state.age}
                          label="Platform"
                          onChange={this.handleChange}
                        >
                          <MenuItem value={10}>Unity</MenuItem>
                          <MenuItem value={20}>WebXR</MenuItem>
                          <MenuItem value={30}>Hololens</MenuItem>
                          <MenuItem value={40}>PowerBI</MenuItem>
                        </Select>
                      </FormControl>
                    </Paper>
                    <hr/>
                    <Paper
                      sx={{
                        p: 2, display: 'flex',
                        flexDirection: 'column',
                        height: 550,
                      }}>
                      <FormGroup>
                        <FormControlLabel control={<Checkbox defaultChecked />} label="BIM Data" />
                        <FormControlLabel control={<Checkbox defaultChecked />} label="Include GUIDS" />
                        <FormControlLabel disabled control={<Checkbox />} label="Include IOT data" />
                      </FormGroup>

                      {this.state.packageReady && <Paper
                        sx={{
                          p: 2, display: 'flex',
                          flexDirection: 'column',
                          height: 80,
                        }}>
                        <FormGroup>
                          <Button variant="contained" onClick={() => this.handleOpen()}>Publish Model</Button>
                        </FormGroup>
                      </Paper>}

                      {this.state.downloadReady && <Paper
                        sx={{
                          p: 2, display: 'flex',
                          flexDirection: 'column',
                          height: 80,
                        }}>
                        {/* <Button variant="contained" onClick={() => moveModel(100)}>Download Model</Button> */}
                        {/* <Button variant="contained" color="success" onClick={() => this.runDownload()}>Download Package</Button> */}
                        <a href="/Lamar_PowerBI_Package_1.zip" download="Lamar_PowerBI_Package_1.zip">
                          <Button variant="contained" color="success" onClick={() => this.runDownload()}>Download Package</Button>
                        </a>
                      </Paper>}
                    </Paper>
                  </Grid>
              


              </Grid>
              <Modal
                open={this.state.open}
                onClose={this.handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={modalStyle}>
                  <Typography id="modal-modal-title" variant="h6" component="h2">
                    Power BI Processing done
                  </Typography>
                  <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    A zip file containing the Power BI visual and an excel BOM is ready for download.
                  </Typography>
                  <Button variant="contained" onClick={() => this.handleClose()}>Done</Button>
                </Box>
              </Modal>

            </Container>

          </>
        }
        {
          !projectDetails &&
          <Container component="main" sx={{ mt: 12, mb: 12, lg: 12 }} maxWidth="lg">
            <Paper sx={{ p: 1, display: 'flex', flexDirection: 'column' }}>
              <h3>No Active Project Selected</h3>
            </Paper>
          </Container>
        }
      </>
    )
  }
}

export default VisualizationView;